/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useMemo, useState } from "react";
import useSelect from "~components/Form/hooks/useSelect";
import { db } from "~/db/db";
import prepareForOptions from "~services/utils/prepareForOptions";

const useFunilStatus = ({ formikRef }) => {
  const funilStatusSelect = useSelect("funilStatusId");
  const [funilStatus, setFunilStatus] = useState(0);
  const [funilStatusSelecionado, setFunilStatusSelecionado] = useState(0);
  const [fila, setFila] = useState(null);

  const [funilStatusList, setFunilStatusList] = useState([]);
  const [funilStatusObj, setFunilStatusObj] = useState({});
  const [funilStatusObjBySlug, setFunilStatusObjBySlug] = useState({});

  useEffect(() => {
    const fetchFunilStatusList = async () => {
      const result = [];
      let obj = {};
      await db.funilStatus.filter((a) => a.ativo).each((item) => {
        if(!obj[`id-` + item.id]) obj[`id-` + item.id] = item;
        
        return result.push(item)
      });
      setFunilStatusObj(obj);
      setFunilStatusList(result);
      setFunilStatusObjBySlug(result.reduce((acc, cur) => {
        acc[cur.slug] = cur;
        return acc;
      }, {}))
    };

    fetchFunilStatusList();
  }, []);

  const optionFunisStatus = useMemo(() => prepareForOptions(funilStatusList, "nome", "id"), [funilStatusList]);

  function onChangeFunilStatus(e) {
    funilStatusSelect.upDateValue(e.value);
    funilStatusSelect.upDateDefaultValue(e || "");
    if (formikRef?.current) {
      formikRef.current.setFieldValue("funilStatusId", e.value);
      setTimeout(() => formikRef.current.setFieldTouched("funilStatusId", true));
    }
    const funilStatusSel = funilStatusList.find(fs => fs.id === e.value);
    setFunilStatusSelecionado(funilStatusSel);
    setFunilStatus(e.value);
  }

  function SetSelectFunilStatus(id) {
    if (optionFunisStatus?.length > 0) {
      const funilStatusOption = optionFunisStatus.find(funilStatus => funilStatus.value === id);
      if (funilStatusOption) {
        onChangeFunilStatus(funilStatusOption);
      }
      setFila(null);
    } else {
      setFila(id);
    }
  }

  useEffect(() => {
    if (fila && optionFunisStatus?.length > 0) {
      SetSelectFunilStatus(fila);
    }
  }, [fila, optionFunisStatus])

  return {
    funilStatusObj,
    funilStatusList,
    optionFunisStatus,
    funilStatusSelecionado,
    onChangeFunilStatus,
    funilStatus,
    funilStatusSelect,
    setFunilStatus,
    SetSelectFunilStatus,
    funilStatusObjBySlug
  };
};

export default useFunilStatus;